import TodoProperties from "./properties/todo-properties"
import DatetimeUtils from "../../../gd/utils/datetime-utils"
import TodoList from "../todo-list/todo-list";
import TaskProperties from "./properties/task-properties";
import TaskView_MessagesHelper from "../../../../item-view/task/manager/messages-helper";
import {TodoType} from "../@type";
import ModelEntity from "../../model-entity";
import {EntityType} from "../../../gd/const/item";

const debug = false
// const debug = "TodoItem"

export default class TodoItem extends ModelEntity {

    public todoList           : TodoList
    public uid                : ID

    public type               : TodoType
    public taskId             : ID | null
    public momentCreated      : Moment | null
    public createdByUserId    : ID | null

    // public isMinimized          : boolean = false // to use in futere see how task todos (converted from message) show more less arrow on the right

    public access             : {
        add : boolean,
        edit : boolean
    }

    public properties       : TaskProperties | TodoProperties

    constructor(todoList:TodoList, data:any) {

        super(data['uid'], EntityType.DYNAMIC_MODEL)

        this.todoList           = todoList
        this.uid                = _.get(data, 'uid', this.todoList.generateId())

        this.type               = _.get(data, 'type', TodoType.TODO)
        this.taskId             = _.get(data, 'taskId', null) // for TASK_ITEM only
        this.momentCreated      = DatetimeUtils.datetimeToMoment(_.get(data,'momentCreated',null))
        this.createdByUserId    = _.get(data,'createdByUserId',null)

        // init access
        this.access = {
            add : this.todoList.access.add,
            edit: this.todoList.access.edit || this.createdByUserId === gd.session.me.id
        };

        if (this.type === TodoType.TASK) {
            this.properties = new TaskProperties(data.properties);
        } else {
            this.properties = new TodoProperties(data.properties);
        }
    }

    // should be used to create new items
    static create(todoList:TodoList, data:any) {

        data.momentCreated      = _.get(data,'momentCreated',moment())
        data.createdByUserId    = _.get(data,'createdByUserId',gd.session.me.id)

        return new TodoItem(todoList, data)
    }

    get name() {return this.properties.getName()}
    get isCompleted() {return this.properties.isCompleted()}

    isTaskMessage(messagesManager?: TaskView_MessagesHelper):boolean {

        // @ts-ignore
        const {messageId} = this.properties
        if (!!messagesManager && messageId) {
            const message = messagesManager.getById(messageId)
            if (message) return true
        }

        return false
    }

    getName = () => this.properties.getName()
    setName = (value:string) => this.properties.setName(value)
    setStatus = (value: ID | boolean) => {
        // @ts-ignore
        this.properties.setStatus(value)
    }
    setUser = (value: ID) => {

        if (this.properties instanceof TodoProperties) {
            this.properties.setUser(value)
        }
    }

    toText(messagesManager?: TaskView_MessagesHelper) {

        const isTaskMessage = this.isTaskMessage(messagesManager)

        if (!!messagesManager && isTaskMessage) {
            const {messageId} = this.properties
            const message = messagesManager.getById(messageId)
            debug && console.log(debug, 'toText', message)
            return message.message
        } else {
            return this.properties.title
        }
    }

    toJSON(): JSONObject {
        switch (this.type) {
            case TodoType.TODO: return {
                uid             : this.uid,
                type            : this.type,
                properties      : this.properties.toJSON(),
                createdByUserId : this.createdByUserId,
                momentCreated   : this.momentCreated?.toJSON(),
            }

            case TodoType.TASK: return {
                uid             : this.uid,
                type            : this.type,
                taskId          : this.taskId,
                createdByUserId : this.createdByUserId,
                momentCreated   : this.momentCreated?.toJSON()
            }

            default: return {}
        }
    }
}
